import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _14266716 = () => interopDefault(import('..\\pages\\appconfigs\\index.vue' /* webpackChunkName: "pages/appconfigs/index" */))
const _17fdf49a = () => interopDefault(import('..\\pages\\banner\\index.vue' /* webpackChunkName: "pages/banner/index" */))
const _4bab9888 = () => interopDefault(import('..\\pages\\category\\index.vue' /* webpackChunkName: "pages/category/index" */))
const _4925624f = () => interopDefault(import('..\\pages\\comment\\index.vue' /* webpackChunkName: "pages/comment/index" */))
const _aac440be = () => interopDefault(import('..\\pages\\feedback\\index.vue' /* webpackChunkName: "pages/feedback/index" */))
const _4576669a = () => interopDefault(import('..\\pages\\forget-password\\index.vue' /* webpackChunkName: "pages/forget-password/index" */))
const _4f0741dd = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _70625193 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _78f8f87b = () => interopDefault(import('..\\pages\\notification\\index.vue' /* webpackChunkName: "pages/notification/index" */))
const _220c7a72 = () => interopDefault(import('..\\pages\\notification-template\\index.vue' /* webpackChunkName: "pages/notification-template/index" */))
const _33e1819c = () => interopDefault(import('..\\pages\\offer\\index.vue' /* webpackChunkName: "pages/offer/index" */))
const _589ca700 = () => interopDefault(import('..\\pages\\order\\index.vue' /* webpackChunkName: "pages/order/index" */))
const _a1986c82 = () => interopDefault(import('..\\pages\\product\\index.vue' /* webpackChunkName: "pages/product/index" */))
const _88909676 = () => interopDefault(import('..\\pages\\profile\\index.vue' /* webpackChunkName: "pages/profile/index" */))
const _4c179d90 = () => interopDefault(import('..\\pages\\shop\\index.vue' /* webpackChunkName: "pages/shop/index" */))
const _18994034 = () => interopDefault(import('..\\pages\\tag\\index.vue' /* webpackChunkName: "pages/tag/index" */))
const _6b891c22 = () => interopDefault(import('..\\pages\\top-banner\\index.vue' /* webpackChunkName: "pages/top-banner/index" */))
const _729b259b = () => interopDefault(import('..\\pages\\user\\index.vue' /* webpackChunkName: "pages/user/index" */))
const _605ad734 = () => interopDefault(import('..\\pages\\award\\award\\index.vue' /* webpackChunkName: "pages/award/award/index" */))
const _4a52d941 = () => interopDefault(import('..\\pages\\award\\campaign\\index.vue' /* webpackChunkName: "pages/award/campaign/index" */))
const _69b9ed04 = () => interopDefault(import('..\\pages\\award\\generate-code\\index.vue' /* webpackChunkName: "pages/award/generate-code/index" */))
const _4c1ae1f8 = () => interopDefault(import('..\\pages\\award\\group\\index.vue' /* webpackChunkName: "pages/award/group/index" */))
const _10a2b082 = () => interopDefault(import('..\\pages\\award\\lucky-codes\\index.vue' /* webpackChunkName: "pages/award/lucky-codes/index" */))
const _5823f71c = () => interopDefault(import('..\\pages\\award\\winner\\index.vue' /* webpackChunkName: "pages/award/winner/index" */))
const _c0ebab30 = () => interopDefault(import('..\\pages\\banner\\new.vue' /* webpackChunkName: "pages/banner/new" */))
const _0c8bf1d6 = () => interopDefault(import('..\\pages\\category\\new.vue' /* webpackChunkName: "pages/category/new" */))
const _670e5514 = () => interopDefault(import('..\\pages\\cms\\page\\index.vue' /* webpackChunkName: "pages/cms/page/index" */))
const _05a0b5be = () => interopDefault(import('..\\pages\\cms\\site\\index.vue' /* webpackChunkName: "pages/cms/site/index" */))
const _e80b7ffe = () => interopDefault(import('..\\pages\\forget-password\\confirm\\index.vue' /* webpackChunkName: "pages/forget-password/confirm/index" */))
const _0db91cbe = () => interopDefault(import('..\\pages\\news\\new.vue' /* webpackChunkName: "pages/news/new" */))
const _4a9f7380 = () => interopDefault(import('..\\pages\\notification-template\\new.vue' /* webpackChunkName: "pages/notification-template/new" */))
const _73c58a00 = () => interopDefault(import('..\\pages\\offer\\new.vue' /* webpackChunkName: "pages/offer/new" */))
const _1e65d34b = () => interopDefault(import('..\\pages\\profile\\change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _34c598de = () => interopDefault(import('..\\pages\\shop\\new.vue' /* webpackChunkName: "pages/shop/new" */))
const _0450d6fc = () => interopDefault(import('..\\pages\\tag\\new.vue' /* webpackChunkName: "pages/tag/new" */))
const _0580695e = () => interopDefault(import('..\\pages\\xrm\\data\\index.vue' /* webpackChunkName: "pages/xrm/data/index" */))
const _d712fc1a = () => interopDefault(import('..\\pages\\xrm\\merchant\\index.vue' /* webpackChunkName: "pages/xrm/merchant/index" */))
const _447a27c6 = () => interopDefault(import('..\\pages\\xrm\\transactions\\index.vue' /* webpackChunkName: "pages/xrm/transactions/index" */))
const _03814f66 = () => interopDefault(import('..\\pages\\xrm\\transactions-report\\index.vue' /* webpackChunkName: "pages/xrm/transactions-report/index" */))
const _035c4d34 = () => interopDefault(import('..\\pages\\award\\award\\new.vue' /* webpackChunkName: "pages/award/award/new" */))
const _9963e662 = () => interopDefault(import('..\\pages\\award\\campaign\\new.vue' /* webpackChunkName: "pages/award/campaign/new" */))
const _43d65752 = () => interopDefault(import('..\\pages\\award\\group\\new.vue' /* webpackChunkName: "pages/award/group/new" */))
const _eb067f60 = () => interopDefault(import('..\\pages\\award\\lucky-codes\\new.vue' /* webpackChunkName: "pages/award/lucky-codes/new" */))
const _69275f80 = () => interopDefault(import('..\\pages\\award\\winner\\new.vue' /* webpackChunkName: "pages/award/winner/new" */))
const _e880db78 = () => interopDefault(import('..\\pages\\cms\\page\\new.vue' /* webpackChunkName: "pages/cms/page/new" */))
const _2472e48c = () => interopDefault(import('..\\pages\\cms\\site\\new.vue' /* webpackChunkName: "pages/cms/site/new" */))
const _13483a01 = () => interopDefault(import('..\\pages\\xrm\\merchant\\new.vue' /* webpackChunkName: "pages/xrm/merchant/new" */))
const _73cefd3b = () => interopDefault(import('..\\pages\\award\\lucky-codes\\qr\\_code.vue' /* webpackChunkName: "pages/award/lucky-codes/qr/_code" */))
const _20b30f64 = () => interopDefault(import('..\\pages\\award\\award\\_id.vue' /* webpackChunkName: "pages/award/award/_id" */))
const _c0cf902e = () => interopDefault(import('..\\pages\\award\\campaign\\_id.vue' /* webpackChunkName: "pages/award/campaign/_id" */))
const _3020826c = () => interopDefault(import('..\\pages\\award\\group\\_id.vue' /* webpackChunkName: "pages/award/group/_id" */))
const _9093094c = () => interopDefault(import('..\\pages\\award\\winner\\_id.vue' /* webpackChunkName: "pages/award/winner/_id" */))
const _fe0f1d38 = () => interopDefault(import('..\\pages\\cms\\page\\_id\\index.vue' /* webpackChunkName: "pages/cms/page/_id/index" */))
const _10bd0fa6 = () => interopDefault(import('..\\pages\\cms\\site\\_id.vue' /* webpackChunkName: "pages/cms/site/_id" */))
const _5dce8300 = () => interopDefault(import('..\\pages\\xrm\\data\\_mobile.vue' /* webpackChunkName: "pages/xrm/data/_mobile" */))
const _00db35ca = () => interopDefault(import('..\\pages\\xrm\\merchant\\_id.vue' /* webpackChunkName: "pages/xrm/merchant/_id" */))
const _f032c7fa = () => interopDefault(import('..\\pages\\cms\\page\\_id\\block\\index.vue' /* webpackChunkName: "pages/cms/page/_id/block/index" */))
const _3d179811 = () => interopDefault(import('..\\pages\\cms\\page\\_id\\block\\new.vue' /* webpackChunkName: "pages/cms/page/_id/block/new" */))
const _10c1f308 = () => interopDefault(import('..\\pages\\cms\\page\\_id\\block\\_blockid.vue' /* webpackChunkName: "pages/cms/page/_id/block/_blockid" */))
const _e85754fc = () => interopDefault(import('..\\pages\\banner\\_id.vue' /* webpackChunkName: "pages/banner/_id" */))
const _0e53c620 = () => interopDefault(import('..\\pages\\category\\_id.vue' /* webpackChunkName: "pages/category/_id" */))
const _3ff5ac77 = () => interopDefault(import('..\\pages\\comment\\_id.vue' /* webpackChunkName: "pages/comment/_id" */))
const _21b15649 = () => interopDefault(import('..\\pages\\feedback\\_id.vue' /* webpackChunkName: "pages/feedback/_id" */))
const _3524c68a = () => interopDefault(import('..\\pages\\news\\_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _720b1d4c = () => interopDefault(import('..\\pages\\notification-template\\_id.vue' /* webpackChunkName: "pages/notification-template/_id" */))
const _9b3133cc = () => interopDefault(import('..\\pages\\offer\\_id.vue' /* webpackChunkName: "pages/offer/_id" */))
const _b9e7f3cc = () => interopDefault(import('..\\pages\\order\\_id\\index.vue' /* webpackChunkName: "pages/order/_id/index" */))
const _ec96acec = () => interopDefault(import('..\\pages\\shop\\_id\\index.vue' /* webpackChunkName: "pages/shop/_id/index" */))
const _2bbc80c8 = () => interopDefault(import('..\\pages\\tag\\_id.vue' /* webpackChunkName: "pages/tag/_id" */))
const _6a5bd2c3 = () => interopDefault(import('..\\pages\\user\\_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _68122a75 = () => interopDefault(import('..\\pages\\order\\_id\\print.vue' /* webpackChunkName: "pages/order/_id/print" */))
const _d0560368 = () => interopDefault(import('..\\pages\\shop\\_id\\category\\index.vue' /* webpackChunkName: "pages/shop/_id/category/index" */))
const _084d6f9a = () => interopDefault(import('..\\pages\\shop\\_id\\contact-info.vue' /* webpackChunkName: "pages/shop/_id/contact-info" */))
const _bdb6c90a = () => interopDefault(import('..\\pages\\shop\\_id\\product\\index.vue' /* webpackChunkName: "pages/shop/_id/product/index" */))
const _1c9bf89a = () => interopDefault(import('..\\pages\\shop\\_id\\category\\new.vue' /* webpackChunkName: "pages/shop/_id/category/new" */))
const _023f1589 = () => interopDefault(import('..\\pages\\shop\\_id\\product\\new.vue' /* webpackChunkName: "pages/shop/_id/product/new" */))
const _9a7af55c = () => interopDefault(import('..\\pages\\shop\\_id\\category\\_categoryId.vue' /* webpackChunkName: "pages/shop/_id/category/_categoryId" */))
const _185e26a0 = () => interopDefault(import('..\\pages\\shop\\_id\\product\\_productId\\index.vue' /* webpackChunkName: "pages/shop/_id/product/_productId/index" */))
const _3678e67a = () => interopDefault(import('..\\pages\\shop\\_id\\product\\_productId\\attribute.vue' /* webpackChunkName: "pages/shop/_id/product/_productId/attribute" */))
const _a3095ed8 = () => interopDefault(import('..\\pages\\shop\\_id\\product\\_productId\\bundle.vue' /* webpackChunkName: "pages/shop/_id/product/_productId/bundle" */))
const _9be4fca0 = () => interopDefault(import('..\\pages\\shop\\_id\\product\\_productId\\gallery.vue' /* webpackChunkName: "pages/shop/_id/product/_productId/gallery" */))
const _f540c274 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/appconfigs",
    component: _14266716,
    name: "appconfigs"
  }, {
    path: "/banner",
    component: _17fdf49a,
    name: "banner"
  }, {
    path: "/category",
    component: _4bab9888,
    name: "category"
  }, {
    path: "/comment",
    component: _4925624f,
    name: "comment"
  }, {
    path: "/feedback",
    component: _aac440be,
    name: "feedback"
  }, {
    path: "/forget-password",
    component: _4576669a,
    name: "forget-password"
  }, {
    path: "/login",
    component: _4f0741dd,
    name: "login"
  }, {
    path: "/news",
    component: _70625193,
    name: "news"
  }, {
    path: "/notification",
    component: _78f8f87b,
    name: "notification"
  }, {
    path: "/notification-template",
    component: _220c7a72,
    name: "notification-template"
  }, {
    path: "/offer",
    component: _33e1819c,
    name: "offer"
  }, {
    path: "/order",
    component: _589ca700,
    name: "order"
  }, {
    path: "/product",
    component: _a1986c82,
    name: "product"
  }, {
    path: "/profile",
    component: _88909676,
    name: "profile"
  }, {
    path: "/shop",
    component: _4c179d90,
    name: "shop"
  }, {
    path: "/tag",
    component: _18994034,
    name: "tag"
  }, {
    path: "/top-banner",
    component: _6b891c22,
    name: "top-banner"
  }, {
    path: "/user",
    component: _729b259b,
    name: "user"
  }, {
    path: "/award/award",
    component: _605ad734,
    name: "award-award"
  }, {
    path: "/award/campaign",
    component: _4a52d941,
    name: "award-campaign"
  }, {
    path: "/award/generate-code",
    component: _69b9ed04,
    name: "award-generate-code"
  }, {
    path: "/award/group",
    component: _4c1ae1f8,
    name: "award-group"
  }, {
    path: "/award/lucky-codes",
    component: _10a2b082,
    name: "award-lucky-codes"
  }, {
    path: "/award/winner",
    component: _5823f71c,
    name: "award-winner"
  }, {
    path: "/banner/new",
    component: _c0ebab30,
    name: "banner-new"
  }, {
    path: "/category/new",
    component: _0c8bf1d6,
    name: "category-new"
  }, {
    path: "/cms/page",
    component: _670e5514,
    name: "cms-page"
  }, {
    path: "/cms/site",
    component: _05a0b5be,
    name: "cms-site"
  }, {
    path: "/forget-password/confirm",
    component: _e80b7ffe,
    name: "forget-password-confirm"
  }, {
    path: "/news/new",
    component: _0db91cbe,
    name: "news-new"
  }, {
    path: "/notification-template/new",
    component: _4a9f7380,
    name: "notification-template-new"
  }, {
    path: "/offer/new",
    component: _73c58a00,
    name: "offer-new"
  }, {
    path: "/profile/change-password",
    component: _1e65d34b,
    name: "profile-change-password"
  }, {
    path: "/shop/new",
    component: _34c598de,
    name: "shop-new"
  }, {
    path: "/tag/new",
    component: _0450d6fc,
    name: "tag-new"
  }, {
    path: "/xrm/data",
    component: _0580695e,
    name: "xrm-data"
  }, {
    path: "/xrm/merchant",
    component: _d712fc1a,
    name: "xrm-merchant"
  }, {
    path: "/xrm/transactions",
    component: _447a27c6,
    name: "xrm-transactions"
  }, {
    path: "/xrm/transactions-report",
    component: _03814f66,
    name: "xrm-transactions-report"
  }, {
    path: "/award/award/new",
    component: _035c4d34,
    name: "award-award-new"
  }, {
    path: "/award/campaign/new",
    component: _9963e662,
    name: "award-campaign-new"
  }, {
    path: "/award/group/new",
    component: _43d65752,
    name: "award-group-new"
  }, {
    path: "/award/lucky-codes/new",
    component: _eb067f60,
    name: "award-lucky-codes-new"
  }, {
    path: "/award/winner/new",
    component: _69275f80,
    name: "award-winner-new"
  }, {
    path: "/cms/page/new",
    component: _e880db78,
    name: "cms-page-new"
  }, {
    path: "/cms/site/new",
    component: _2472e48c,
    name: "cms-site-new"
  }, {
    path: "/xrm/merchant/new",
    component: _13483a01,
    name: "xrm-merchant-new"
  }, {
    path: "/award/lucky-codes/qr/:code",
    component: _73cefd3b,
    name: "award-lucky-codes-qr-code"
  }, {
    path: "/award/award/:id",
    component: _20b30f64,
    name: "award-award-id"
  }, {
    path: "/award/campaign/:id",
    component: _c0cf902e,
    name: "award-campaign-id"
  }, {
    path: "/award/group/:id",
    component: _3020826c,
    name: "award-group-id"
  }, {
    path: "/award/winner/:id",
    component: _9093094c,
    name: "award-winner-id"
  }, {
    path: "/cms/page/:id",
    component: _fe0f1d38,
    name: "cms-page-id"
  }, {
    path: "/cms/site/:id",
    component: _10bd0fa6,
    name: "cms-site-id"
  }, {
    path: "/xrm/data/:mobile",
    component: _5dce8300,
    name: "xrm-data-mobile"
  }, {
    path: "/xrm/merchant/:id",
    component: _00db35ca,
    name: "xrm-merchant-id"
  }, {
    path: "/cms/page/:id/block",
    component: _f032c7fa,
    name: "cms-page-id-block"
  }, {
    path: "/cms/page/:id/block/new",
    component: _3d179811,
    name: "cms-page-id-block-new"
  }, {
    path: "/cms/page/:id/block/:blockid",
    component: _10c1f308,
    name: "cms-page-id-block-blockid"
  }, {
    path: "/banner/:id",
    component: _e85754fc,
    name: "banner-id"
  }, {
    path: "/category/:id",
    component: _0e53c620,
    name: "category-id"
  }, {
    path: "/comment/:id",
    component: _3ff5ac77,
    name: "comment-id"
  }, {
    path: "/feedback/:id",
    component: _21b15649,
    name: "feedback-id"
  }, {
    path: "/news/:id",
    component: _3524c68a,
    name: "news-id"
  }, {
    path: "/notification-template/:id",
    component: _720b1d4c,
    name: "notification-template-id"
  }, {
    path: "/offer/:id",
    component: _9b3133cc,
    name: "offer-id"
  }, {
    path: "/order/:id",
    component: _b9e7f3cc,
    name: "order-id"
  }, {
    path: "/shop/:id",
    component: _ec96acec,
    name: "shop-id"
  }, {
    path: "/tag/:id",
    component: _2bbc80c8,
    name: "tag-id"
  }, {
    path: "/user/:id",
    component: _6a5bd2c3,
    name: "user-id"
  }, {
    path: "/order/:id/print",
    component: _68122a75,
    name: "order-id-print"
  }, {
    path: "/shop/:id/category",
    component: _d0560368,
    name: "shop-id-category"
  }, {
    path: "/shop/:id/contact-info",
    component: _084d6f9a,
    name: "shop-id-contact-info"
  }, {
    path: "/shop/:id/product",
    component: _bdb6c90a,
    name: "shop-id-product"
  }, {
    path: "/shop/:id/category/new",
    component: _1c9bf89a,
    name: "shop-id-category-new"
  }, {
    path: "/shop/:id/product/new",
    component: _023f1589,
    name: "shop-id-product-new"
  }, {
    path: "/shop/:id/category/:categoryId",
    component: _9a7af55c,
    name: "shop-id-category-categoryId"
  }, {
    path: "/shop/:id/product/:productId",
    component: _185e26a0,
    name: "shop-id-product-productId"
  }, {
    path: "/shop/:id/product/:productId/attribute",
    component: _3678e67a,
    name: "shop-id-product-productId-attribute"
  }, {
    path: "/shop/:id/product/:productId/bundle",
    component: _a3095ed8,
    name: "shop-id-product-productId-bundle"
  }, {
    path: "/shop/:id/product/:productId/gallery",
    component: _9be4fca0,
    name: "shop-id-product-productId-gallery"
  }, {
    path: "/",
    component: _f540c274,
    name: "index"
  }],

  parseQuery: function(query) {
            const qs = require('qs');
            return qs.parse(query);
        },
  stringifyQuery: function(query) {
            const qs = require('qs');
            var result = qs.stringify(query);

            return result ? ('?' + result) : '';
        },
  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
